import type { TypographyProps } from "@mui/material";
import { Box, Tooltip, Typography } from "@mui/material";
import useMergedSx from "@entrilia/shared/hooks/useMergedSx";

interface Props {
  label: string;
  tooltipText?: string;
  typographyProps?: TypographyProps;
}

const TypographyWithTooltip = ({ label, tooltipText, typographyProps }: Props) => {
  const hasTooltip = Boolean(tooltipText);
  const { sx: typographySx, ...other } = typographyProps || {};

  const mergedTypographySx = useMergedSx(typographySx, {
    textDecoration: "underline",
    textDecorationStyle: "dotted",
    cursor: "help",
  });

  return (
    <Box sx={{ gap: 1, display: "flex", alignItems: "center" }}>
      {hasTooltip ? (
        <Tooltip
          sx={(theme) => ({ maxWidth: theme.spacing(22.5), textAlign: "center" })}
          title={tooltipText}
          placement="bottom"
          arrow
          disableInteractive
        >
          <Typography {...other} sx={mergedTypographySx}>
            {label}
          </Typography>
        </Tooltip>
      ) : (
        <Typography {...typographyProps}>{label}</Typography>
      )}
    </Box>
  );
};

export default TypographyWithTooltip;
